// One file per area so areas can be translated independently. Each exports
// { en }, the source, which defines the keys. Every other language lives in
// messages/<lang>/<area>.ts, one file per area and language, and is loaded
// on its own (see ../index.tsx): only English ships in the main bundle.
// Missing keys fall back to English.
import { hub } from "./hub";
import { nav } from "./nav";
import { paywall } from "./paywall";
import { pricing } from "./pricing";
import { studio } from "./studio";
import { studioOptions } from "./studioOptions";
import { auth } from "./auth";
import { checkout } from "./checkout";
import { upsell } from "./upsell";
import { home } from "./home";
import { voice } from "./voice";
import { library } from "./library";
import { train } from "./train";
import { referral } from "./referral";

const AREAS = [
  hub,
  nav,
  paywall,
  pricing,
  studio,
  studioOptions,
  auth,
  checkout,
  upsell,
  home,
  voice,
  library,
  train,
  referral,
] as const;

export const en = Object.assign(
  {},
  ...AREAS.map((a) => a.en),
) as typeof hub.en &
  typeof nav.en &
  typeof paywall.en &
  typeof pricing.en &
  typeof studio.en &
  typeof studioOptions.en &
  typeof auth.en &
  typeof checkout.en &
  typeof upsell.en &
  typeof home.en &
  typeof voice.en &
  typeof library.en &
  typeof train.en &
  typeof referral.en;
export type MessageKey = keyof typeof en;
export type Dict = Partial<Record<MessageKey, string>>;
